import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NoIndex from "./NoIndex";
import useAuthApi from "../services/LandingPage/useAuthApi";
import { GlobalContext } from "../Context/GlobalContext";

const IdentityPage = () => {
  console.log(" IDENTITY PAGE RUNNING");
  const navigate = useNavigate();

  const { getUserAccess, fetchSubscriptionDetails, loading } = useAuthApi();

  const tempUser = JSON.parse(sessionStorage.getItem("tempUser"));

  console.log("TEMP USER:", tempUser);
  const { setUser, setPower } = useContext(GlobalContext);

  const [verifying, setVerifying] = useState(true);

  //  UUID Generator
  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );

  const verifyToken = async () => {
    try {
      if (!tempUser) {
        console.log(" No tempUser found");
        navigate("/");
        return;
      }

      const userData = tempUser;
      const userId = tempUser.userid;

      console.log(" USER ID:", userId);

      const sessionID = generateUUID();
      sessionStorage.setItem("sessionID", sessionID);

      const subscriptionResponse = await fetchSubscriptionDetails(userId);

      console.log("SUBSCRIPTION:", subscriptionResponse);

      const subscriptionData =
        subscriptionResponse?.data ?? subscriptionResponse?.response ?? {};

      // NO PLAN
      if (
        subscriptionResponse?.responseCode !== "00" ||
        !subscriptionData?.fk_plan_id
      ) {
        console.log(" No plan → demo");

        sessionStorage.removeItem("user");
        sessionStorage.setItem("power", "0");
        setPower("0");

        navigate("/contact-demo");
        return;
      }

      //  EXPIRED
      if (subscriptionData?.is_active !== "1") {
        console.log(" Expired plan");

        sessionStorage.removeItem("user");
        sessionStorage.setItem("power", "0");
        setPower("0");

        navigate("/Profile/Plans");
        return;
      }

      //  ACTIVE PLAN
      console.log(" Active plan");

      sessionStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      sessionStorage.setItem("power", "1");
      setPower("1");

      const accessResponse = await getUserAccess(userId);

      if (accessResponse?.responseCode === "00") {
        const entitlementData =
          accessResponse?.data ||
          accessResponse?.response?.data ||
          accessResponse?.response ||
          [];

        sessionStorage.setItem("entitlement", JSON.stringify(entitlementData));
      }

      navigate("/dashboard");
    } catch (error) {
      console.error("Verification error:", error);
      navigate("/");
    } finally {
      setVerifying(false);
    }
  };

  useEffect(() => {
    verifyToken();
  }, []);

  return (
    <div className="h-screen w-full flex items-center justify-center montserrat-font-1">
      <NoIndex />

      {(loading || verifying) && (
        <div className="flex flex-col items-center gap-4 montserrat-font-1">
          <div className="h-14 w-14 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600 text-sm font-medium montserrat-font-2">
            Verifying your account...
          </p>
        </div>
      )}
    </div>
  );
};

export default IdentityPage;
